import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isNumber from "lodash/isNumber";
var _excluded = ["size", "UNSAFE_size"];

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
var SIZES = {
  small: 16,
  medium: 20,
  large: 24
};

var withSize = function withSize(Icon) {
  var SizedIcon = function SizedIcon(_ref) {
    var size = _ref.size,
        UNSAFE_size = _ref.UNSAFE_size,
        props = _objectWithoutProperties(_ref, _excluded);

    var actualSize = _isNumber(UNSAFE_size) ? UNSAFE_size : SIZES[size];
    return /*#__PURE__*/React.createElement(Icon, _extends({
      focusable: "false",
      height: actualSize,
      width: actualSize
    }, props));
  };

  SizedIcon.propTypes = {
    size: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(SIZES))]),
    UNSAFE_size: PropTypes.number
  };
  SizedIcon.defaultProps = {
    size: 'medium',
    UNSAFE_size: null
  };
  SizedIcon.isIcon = true;
  return SizedIcon;
};

export default withSize;